import './ActivityRowActions.less';

import TableActionButton from 'components/shared/buttons/TableActionButton';
import AccessiblePopconfirm from 'components/statements/table/AccessiblePopconfirm';
import ProfiBazaTooltip from 'layout/ProfiBazaTooltip';
import React from 'react';
import { ActivityListItemDto } from 'services/src/models';

interface IProps {
	record: ActivityListItemDto;
	editable?: boolean;
	onPreview: () => void;
	onEdit: () => void;
	onClone: () => void;
	onDelete: () => void;
}

const ActivityRowActions: React.FC<IProps> = (props) => {
	const { record, editable } = props;

	return (
		<div className="activity-row-actions">
			<span className="activity-row-actions__slot">
				<ProfiBazaTooltip placement="top" title="Szczegóły">
					<TableActionButton
						kind="DETAILS"
						label="Szczegóły"
						onClick={props.onPreview}
					/>
				</ProfiBazaTooltip>
			</span>
			<span className="activity-row-actions__slot">
				{editable && !record.isFrozen && (
					<ProfiBazaTooltip placement="top" title="Edytuj">
						<TableActionButton
							kind="EDIT"
							label="Edytuj"
							onClick={props.onEdit}
						/>
					</ProfiBazaTooltip>
				)}
			</span>
			<span className="activity-row-actions__slot">
				{editable && record.id && (
					<ProfiBazaTooltip placement="top" title="Sklonuj">
						<TableActionButton
							kind="CLONE"
							label="Sklonuj"
							onClick={props.onClone}
						/>
					</ProfiBazaTooltip>
				)}
			</span>
			<span className="activity-row-actions__slot">
				{editable && !record.activityPatternId && !record.isFrozen && (
					<ProfiBazaTooltip placement="top" title="Usuń">
						<AccessiblePopconfirm
							title="Czy na pewno chcesz usunąć element?"
							onConfirm={props.onDelete}
						>
							<TableActionButton kind="DELETE" label="Usuń" />
						</AccessiblePopconfirm>
					</ProfiBazaTooltip>
				)}
			</span>
		</div>
	);
};

export default ActivityRowActions;
